"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNativeLink = exports.NativeLinkProvider = void 0;
const React = require("react");
const react_1 = require("react");
const NativeLinkContext_1 = require("./NativeLinkContext");
const NativeLinkContext = (0, react_1.createContext)({});
const NativeLinkProvider = ({ children }) => {
    const [nativeClient] = (0, react_1.useState)(() => new NativeLinkContext_1.NativeLinkClient());
    return (React.createElement(NativeLinkContext.Provider, { value: { nativeClient } }, children));
};
exports.NativeLinkProvider = NativeLinkProvider;
const useNativeLink = () => {
    const context = (0, react_1.useContext)(NativeLinkContext);
    return context;
};
exports.useNativeLink = useNativeLink;
//# sourceMappingURL=NativeLinkProvider.js.map